'use strict';


import AOS from 'aos';

// window.$ = $;
// window.jQuery = $;

window.AOS = AOS;

$(function () {
  AOS.init({
    duration: 1000,
  })  
});